export default {
  methods: {
    handleChangeElement({ id = '', value = '', extraData }) {
      this.$emit('onChangeElement', { question: id, answer: value, additional_data: extraData });
    },
  },
};
